import { FC, useState } from "react";
import styles from "./index.module.css";
import { ProductItem } from "../newCheckoutProductItem/ProductItem";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";

type Props = {
  order: any;
  config: any;
};

const InfoOrderItens: FC<Props> = ({ order, config }) => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <div className={styles.content}>
      <div className={styles.main}>
        <h4>Produtos</h4>
        {isOpen ? (
          <FaAngleDown onClick={() => setIsOpen(false)} />
        ) : (
          <FaAngleUp onClick={() => setIsOpen(true)} />
        )}
      </div>

      {isOpen && (
        <div className={styles.finalize_order_details}>
          {order &&
            order.products.map((prod: any) => (
              <ProductItem
                product={prod}
                key={prod.id}
                showOutStock={config?.content.pdv.showOutStock}
                motorTotvs={false}
                canChange={false}
                hasCoupon={false}
                omitGrid={config?.content?.pdv?.omitGrid}
              />
            ))}
        </div>
      )}
    </div>
  );
};

export { InfoOrderItens };
